// extracted by mini-css-extract-plugin
export default {"buttons":"MenuButtons_buttons__0X85j","button":"MenuButtons_button__RH77e","icon":"MenuButtons_icon__YxYZ-","menu_text":"MenuButtons_menu_text__ncnjm"};